import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, OnDestroy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { AccountService } from '../../services/account.service';
@Component({
  selector: 'custom-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss']
})
export class CaptchaComponent implements OnInit, OnChanges, OnDestroy {
  requestCaptcha: any;
  @Input() label;
  @Input() help;
  @Input() placeholder = '';
  @Input() control: AbstractControl;
  @Input() showErrors: Boolean;
  @Input() resetOnError = false;
  @Input() excludeChars: string;
  @Output() captchaRequest = new EventEmitter();
  interval;
  constructor(private accountservice: AccountService) {}

  async ngOnInit() {
    await this.initCaptcha();
    this.refreshCaptcha();
  }
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['resetOnError']) {
      if (this.resetOnError === true) {
        clearInterval(this.interval);
        this.initCaptcha();
        this.refreshCaptcha();
      }
    }
  }
  ngOnDestroy() {
    clearInterval(this.interval);
  }
  refreshCaptcha() {
    this.interval = setInterval(() => {
      this.initCaptcha();
    }, 60 * 2 * 1000);
  }

  async initCaptcha() {
    try {
      let request = await this.accountservice.requestCaptcha();
      this.requestCaptcha = request;
      this.captchaRequest.emit(request);
      // if (request.required) {
      //       this.control.setValue('test');
      //     }
    } catch (e) {}
  }
  resetCaptcha() {
    clearInterval(this.interval);
    this.initCaptcha();
    this.refreshCaptcha();
  }
}
